<!-- 特典を探す 中カテゴリ分類選択 -->
<template>
  <div class="crly-m-common-search-keyword-middle-category">
    <template v-for="(cat, index) in CONST.MIDDLE_CATEGORY_TYPE">
      <CrlyAtomsCommonSearchKeywordMiddleCategoryBtn
        :key="index"
        :category="cat"
        :active="activeMidCat"
        @clickMidCatBtn="clickMidCatBtn"
      />
    </template>
  </div>
</template>

<script>
import CrlyAtomsCommonSearchKeywordMiddleCategoryBtn from "@crly/components/atoms/common/search/keyword/MiddleCategoryBtn.vue";
export default {
  name: "CrlyMoleculesCommonSearchKeywordMiddleCategory",
  components: {
    CrlyAtomsCommonSearchKeywordMiddleCategoryBtn
  },
  data() {
    return {
      /**
       * 選択中のカテゴリ
       */
      activeMidCat: 1
    };
  },
  methods: {
    /**
     * カテゴリクリックイベント
     * @param {Number} category 選択されたカテゴリ
     */
    clickMidCatBtn(category) {
      this.activeMidCat = category;
      this.$emit("changeActiveMiddleCategory", category);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@crly/assets/css/molecules/common/search/keyword/middleCategory.scss";
</style>